<template>
  <div>
    <div class="row align-items-center">
      <LmCheckbox
        class="col-12 font-weight-bold"
        variant="switch"
        :labelSingle="$t('visibility_depend_on_condition')"
        v-model="visibilityDependOnConditions.isActive"
      />
    </div>
    <p v-if="visibilityDependOnConditions.isActive" class="m-0 mt-2 col-12 pl-0">{{$t('show_field_if')}}</p>
    <template v-if="visibilityDependOnConditions.isActive">
      <div
        class="d-flex align-items-center w-100 my-3"
        v-for="(condition, index) in visibilityDependOnConditions.conditions"
        :key="index"
      >
        <LmSelect
          style="flex: 0 0 28%"
          :options="leftValueToCompareOptions()"
          v-model="condition.leftValueToCompare"
        />
        <p style="flex: 0 0 5%" class="mb-3 d-flex justify-content-center" v-if="condition.leftValueToCompare">{{$t('Is')}}</p>
        <LmSelect
          style="flex: 0 0 28%"
          v-if="condition.leftValueToCompare"
          :options="getCompareOptions(condition)"
          v-model="condition.comparation"
        />
        <p style="flex: 0 0 5%" class="mb-3 d-flex justify-content-center" v-if="condition.comparation">{{$t('To')}}</p>
        <Component
          style="flex: 0 0 28%"
          v-if="condition.comparation"
          :is="getRightValueComponent(condition)"
          v-bind="getRigthValueOptions(condition)"
          v-model="condition.rightValueToCompare"
        />
        <font-awesome-icon v-if="visibilityDependOnConditions.conditions.length > 1" class="clickable mb-3" style="flex: 0 0 6%" icon="trash" @click="removeCondition(index)" />
      </div>
    </template>
    <LmButton
      v-if="visibilityDependOnConditions.isActive"
      type="submit"
      buttonClass="btn-primary mt-4"
      :value="$t('add_conditional')"
      @click="addCondition"
    />
  </div>
</template>

<script>
// Components
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmSelect from '@/components/form/elements/LmSelect'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmButton from '@/components/form/elements/LmButton'

// Utils
import _ from 'lodash'

export default {
  inject: {
    context: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      rightComponentToRender: [],
      rightComponentOptions: [],
      rightComponentPathToGetOptions: [],
      toCompareOptions: []
    }
  },
  components: {
    LmTextInput,
    LmSelect,
    LmButton,
    LmCheckbox,
    LmTreeSelect

  },
  methods: {
    removeCondition (index) {
      this.visibilityDependOnConditions.conditions.splice(index, 1)
    },
    addCondition () {
      this.visibilityDependOnConditions.conditions.push({
        leftValueToCompare: null,
        comparation: null,
        rightValueToCompare: null
      })
    },

    leftValueToCompareOptions () {
      const availables = ['LmTextInput', 'LmNumberInput', 'LmNumberInputV2', 'LmEmailInput', 'LmTextArea', 'LmPassword', 'LmSelect', 'LmRadio', 'LmRadio', 'LmCheckbox', 'LmTreeSelect']
      const options = {
        disabledOption: 'Seleccione una opción',
        content: []
      }
      // TODO. no deberia mostrarme a mi mismo
      options.content = this.context.formElements
        .filter(el => availables.includes(el.componentName))
        .filter(el => el.formObjectToSendToServerProperty !== this.self)
        .map(el => {
          return {
            text: el.componentProps.label || el.componentProps.labelSingle,
            value: el.formObjectToSendToServerProperty
          }
        })
      return options
    },

    getCompareOptions (condition) {
      const component = this.context.formElements.find(el => el.formObjectToSendToServerProperty === condition.leftValueToCompare)
      if (!component) return null
      const stringOptions = [
        { value: '===', text: this.$t('equal') },
        { value: '!==', text: this.$t('different') }
      ]
      const numberOptions = [
        { value: '===', text: this.$t('equal') },
        { value: '!==', text: this.$t('different') },
        { value: '>', text: this.$t('higher') },
        { value: '>=', text: this.$t('greater_than_or_equal') },
        { value: '<', text: this.$t('less') },
        { value: '<=', text: this.$t('less_than_or_equal') }
      ]
      let options = []
      switch (component.componentName) {
        case 'LmTextInput':
        case 'LmNumberInput':
        case 'LmEmailInput':
        case 'LmTextArea':
        case 'LmPassword':
        case 'LmSelect':
        case 'LmRadio':
        case 'LmCheckbox':
        case 'LmTreeSelect':
          options = stringOptions
          break
        case 'LmNumberInputV2':
          options = numberOptions
          break
      }
      return {
        content: options,
        disabledOption: 'Seleccione una opción'
      }
    },

    getRightValueComponent (condition) {
      const component = this.context.formElements.find(el => el.formObjectToSendToServerProperty === condition.leftValueToCompare)
      if (!component) return null
      let rightComponentToRender = ''
      switch (component.componentName) {
        case 'LmTextInput':
        case 'LmNumberInput':
        case 'LmEmailInput':
        case 'LmTextArea':
        case 'LmPassword':
        case 'LmNumberInputV2':
          rightComponentToRender = 'LmTextInput'
          break
        case 'LmRadio':
        case 'LmCheckbox':
        case 'LmSelect':
          rightComponentToRender = 'LmSelect'
          break
        case 'LmTreeSelect':
          rightComponentToRender = 'LmTreeSelect'
          break
      }
      return rightComponentToRender
    },

    getRigthValueOptions (condition) {
      const componentFound = this.context.formElements.find(el => el.formObjectToSendToServerProperty === condition.leftValueToCompare)
      const component = _.cloneDeep(componentFound)
      if (!component) return null
      delete component.componentProps.label

      if (component.componentName === 'LmCheckbox') {
        delete component.componentProps.labelSingle
        delete component.componentProps.options
        component.componentProps.options = {
          disabledOption: 'Seleccione una opción',
          content: [
            {
              text: component.componentProps.checkValue || 'Checkeado',
              value: component.componentProps.checkValue || 'true'
            },
            {
              text: component.componentProps.uncheckValue || 'DesCheckeado',
              value: component.componentProps.uncheckValue || 'false'
            }
          ]
        }
      }

      if (component.componentName === 'LmRadio') {
        component.componentProps.options = {
          disabledOption: 'Selecciona una opción',
          content: component.componentProps.options
        }
      }

      return component.componentProps
    }
  },
  props: {
    visibilityDependOnConditions: {
      type: Object,
      default: () => ({
        isActive: false,
        conditions: []
      })
    },
    self: {
      type: String,
      default: null
    }
  },
  created () {
    if (!this.visibilityDependOnConditions.conditions.length) {
      this.addCondition()
    }
  }
}
</script>
